/* eslint-disable max-classes-per-file */
import { ForsorjningskallaAggregat, ForsorjningskallaTyp } from "~app/common/models/forsorjningskalla";
import { CommandBase, ICommand } from "../../../../common/services/cqs/commandManager";

export class SetOverenskommenKvantitetProduktionsomradeCommand extends CommandBase {
    kundorderradId: number;
    produktionsomradeId: number;
    kvantitet: number;

    constructor(init: (instance: SetOverenskommenKvantitetProduktionsomradeCommand) => void) {
        super("SetOverenskommenKvantitetProduktionsomradeCommand");
        init(this);
    }
}

export class SetOverenskommenKvantitetTerminalCommand extends CommandBase {
    kundorderradId: number;
    mottagningsplatsId: number;
    kvantitet: number;

    constructor(init: (instance: SetOverenskommenKvantitetTerminalCommand) => void) {
        super("SetOverenskommenKvantitetTerminalCommand");
        init(this);
    }
}

export class SetOverenskommenKvantitetLevorderCommand extends CommandBase {
    kundorderradId: number;
    leverantorsorderradId: number;
    kvantitet: number;

    constructor(init: (instance: SetOverenskommenKvantitetLevorderCommand) => void) {
        super("SetOverenskommenKvantitetLevorderCommand");
        init(this);
    }
}

export class OverenskommentKvantitetCommandFactory {
    static createSetOverenskommentKvantitetCommand(model: ForsorjningskallaAggregat, kundorderradId: number, kvantitet: number): ICommand {
        switch (model.typ) {
            case ForsorjningskallaTyp.Produktionsomrade:
                return new SetOverenskommenKvantitetProduktionsomradeCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.produktionsomradeId = model.id;
                    c.kvantitet = kvantitet;
                });
            case ForsorjningskallaTyp.Terminal:
                return new SetOverenskommenKvantitetTerminalCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.mottagningsplatsId = model.id;
                    c.kvantitet = kvantitet;
                });
            case ForsorjningskallaTyp.Leverantorsorder:
                return new SetOverenskommenKvantitetLevorderCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.leverantorsorderradId = model.id;
                    c.kvantitet = kvantitet;
                });
            default:
                throw new Error(`Odefinierad typ: ${model.typ}`);
        }
    }
}
